/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import clsx from 'clsx';

import useStyles from './styles';

const CarouselRow = ({
  triplet, setCurrentImage, listImages,
}) => {
  const styles = useStyles();

  useEffect(() => {
    setCurrentImage(triplet[1]);
  }, [setCurrentImage, triplet]);

  return (
    <Grid container spacing={3} justify="center">
      <Grid item>
        <Paper
          elevation={0}
          className={clsx({
            [styles.nonPrimaryPaper]: true,
            [styles.customBorder]: triplet[0] !== undefined,
            [styles.filterImage]: triplet[0] !== undefined,
          })}>
          { triplet[0] !== undefined
            ? <>
                <img
                  src={triplet[0].imageUrl}
                  width='100%'
                  height='100%'
                  alt='image-1'
                />
                <div style={
                  {
                    textAlign: 'center', padding: '5px', fontSize: '14px', fontWeight: 'bold',
                  }
                  }>
                  Foto {
                    listImages ? listImages.findIndex((img) => img.id === triplet[0].id) + 1 : 1
                  }
                </div>
              </>
            : null }
        </Paper>
      </Grid>
      <Grid item>
        <Paper elevation={0}
        className={clsx({
          [styles.primaryPaper]: true,
          [styles.customBorder]: triplet[1] !== undefined,
          [styles.firstBorder]: triplet[1] !== undefined,
        })} >
          <>
            <img
              src={triplet[1].imageUrl}
              width='100%'
              height='100%'
              objectfit='contain'
              alt='image-2'
            />
            <div style={
                {
                  textAlign: 'center', padding: '5px', fontSize: '14px', fontWeight: 'bold',
                }
              }>
              Foto {listImages ? listImages.findIndex((img) => img.id === triplet[1].id) + 1 : 2}
            </div>
          </>
        </Paper>
      </Grid>
      <Grid item>
        <Paper
          elevation={0}
          className={clsx({
            [styles.nonPrimaryPaper]: true,
            [styles.customBorder]: triplet[2] !== undefined,
            [styles.filterImage]: triplet[2] !== undefined,
          })} >
          { triplet[2] !== undefined
            ? <>
                <img
                  src={triplet[2].imageUrl}
                  width='100%'
                  height='100%'
                  objectfit='contain'
                  alt='image-3'
                />
                <div style={
                    {
                      textAlign: 'center', padding: '5px', fontSize: '14px', fontWeight: 'bold',
                    }
                  }>
                  Foto {
                    listImages ? listImages.findIndex((img) => img.id === triplet[2].id) + 1 : 3
                  }
                </div>
              </>
            : null }
        </Paper>
      </Grid>
    </Grid>

  );
};

export default CarouselRow;
